import { createAction, createReducer } from "redux-act";

export const showMessage: any = createAction("show message");
export const hideMessage: any = createAction("hide message");
export const toggleHelp: any = createAction("app - toggle help");
export const toggleIds: any = createAction("app - toggle ids");
export const toggleMenu: any = createAction("app - toggle menu");
export const setMenu: any = createAction("app - set menu");


export default createReducer({
    [showMessage]: (state, payload) => {
      // type should be one of error, success, warning
      return {
        ...state, 
        message: {
          type: payload.type,
          message: payload.message
        }
      };
    },
    [hideMessage]: (state) => {
      return {
        ...state, 
        message: {
          type: "",
          message: ""
        }
      };
    },
    [toggleHelp]: (state) => {
      const show = !state.showHelp;
      return {
        ...state, 
        showHelp: show
      };
    },
    [toggleHelp]: (state) => {
      const show = !state.showIds;
      return {
        ...state, 
        showIds: show
      };
    },
    [toggleMenu]: (state) => {
      const show = !state.showMenu;
      return {
        ...state, 
        showMenu: show
      };
    },
    [setMenu]: (state, menuOpen: boolean) => {
      const show = menuOpen;
      return {
        ...state, 
        showMenu: show
      };
    }
  }, {
    message: {
      type: "",
      message: "",
    },
    showHelp: false,
    showIds: false,
    showWelcomeModal: false,
    seenWelcomeModal: false,
    showMenu: false,
});